import { render, staticRenderFns } from "./UserOnboardView.vue?vue&type=template&id=be8b547a&scoped=true"
import script from "./UserOnboardView.vue?vue&type=script&lang=js"
export * from "./UserOnboardView.vue?vue&type=script&lang=js"
import style0 from "./UserOnboardView.vue?vue&type=style&index=0&id=be8b547a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be8b547a",
  null
  
)

export default component.exports